import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {
    SeparatorControlOptions,
    SeparatorOrientationEnum
} from "PageBuilder/pagebuilder/Controls/ControlsList/SeparatorControl.Options";
import {DropDownProperty} from "InternalShared/PageBuilder/Controls/Properties/DropDownProperty";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";


declare let rednaoPDFInvoiceParams:any;
export class SeparatorControl extends PDFControlBase{


    GetStyles(): GroupProperties[] {

            return [
                DimensionStyleSet.GetStyles(this)

            ];
    }
    public AllowedResizeDirection:AllowedResizeDirection="horizontal";
    public Options:SeparatorControlOptions;
    private properties:GroupProperties[];



    public InternalInitialize() {
        this.StyleManager.AddStyleSet('p', {'padding': '0','margin':0});
    }


    public NeedTranslations(): boolean {
        return true;
    }

    public GetTranslatedText(): any {
        return '';
    }

    protected InternalGenerateHtml($container: JQuery) {
        let $horizontalDiv=null;
        if(this.Options.Orientation==SeparatorOrientationEnum.Horizontal)
            $horizontalDiv=jQuery(`<div class="rule" style="width: 100%; border-top:${this.Options.BorderStyle} ${this.Options.BorderSize} ${this.Options.BorderColor}">&nbsp;</div>`);
        else
            $horizontalDiv=jQuery(`<div class="rule" style="height: ${parseInt(this.Options.Styles.Height)}px; border-left:${this.Options.BorderStyle} ${this.Options.BorderSize} ${this.Options.BorderColor}"">&nbsp;</div>`);

        /*let $hr=jQuery('<hr style="width: 100%;"/>');*/
        $container.append($horizontalDiv);
    }

    public GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {
            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new DropDownProperty(this,'Orientation').SetLabel('Orientation')
                        .AddOption("Horizontal","Horizontal")
                        .AddOption("Vertical","Vertical")
                        .OnChange(e=>{
                            let width:any=this.$element.outerWidth();
                            let heigh:any=this.$element.outerHeight();
                            this.Options.Styles.Width=heigh+'px';
                            this.Options.Styles.Height=width+'px';
                            if(this.Options.Orientation==SeparatorOrientationEnum.Horizontal)
                                this.AllowedResizeDirection="horizontal";
                            else
                                this.AllowedResizeDirection="vertical";
                        }),
                    new NumberProperty(this,"BorderSize").SetLabel("Size"),
                    new DropDownProperty(this,'BorderStyle').SetLabel('Style')
                        .AddOption('Solid','solid')
                        .AddOption('Dotted','dotted')
                        .AddOption('Dashed','dashed'),
                    new ColorProperty(this,"BorderColor").SetLabel("Color")
                ])];
        }

        return this.properties;
    }


    public AfterRefresh() {
        let height:number=this.$element.find('.elementContent').height();
        this.$element.velocity('stop',true);
        this.$element.velocity(200,"easeInExp");

    }

    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new SeparatorControlOptions().Merge({Styles:{Left:'2%',Width:'96%'}}));
        });
    }
}
